module.exports = __webpack_public_path__ + "static/media/phone_7.dfc9925d.png";